<template>
  <div>
    <w-obj-list-table></w-obj-list-table>
  </div>
</template>

<script>
import WObjListTable from './components/ObjListTable';

export default {
  name: 'WObjCollectSetting',
  components: {
    WObjListTable,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/SnmpTrap/ObjCollectSetting.vue